import React from 'react';

export default function FwClockIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-clock' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
